import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import DropZone from 'react-dropzone';
import FileChooser from '../../Common/FileChooser';
import Icon from '../../Common/Icon';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import ImportErrorRow from '../../Common/ImportErrorRow';
import Button from '../../Common/Button';

export default class LocationImportDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isDropZoneActive: false,
            droppedFile: null,
            selectedFile: null,
            isFormValid: true,
            isImporting: false,
            importErrors: [],
            fileInputTarget: null
        }
    }

    onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({
                selectedFile: file,
                droppedFile: null,
                isFormValid: true,
                importErrors: [],
                fileInputTarget: e.target
            });
        }
    }

    onDrop = (files) => {
        let droppedFile = (files && files.length > 0) ? files[0] : null;

        if (droppedFile) {
            if (droppedFile.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                Notification("error", "Invalid File Type", "You must pick an Excel document with .xlsx extension");
                this.setState({ isDropZoneActive: false });
            } else {
                this.setState({
                    droppedFile: droppedFile,
                    selectedFile: null,
                    isDropZoneActive: false,
                    importErrors: []
                });
            }
        }
    }

    onDragEnter = () => {
        this.setState({ isDropZoneActive: true });
    }

    onDragLeave = () => {
        this.setState({ isDropZoneActive: false });
    }

    onImportClick = () => {
        if (this.state.droppedFile) {
            this.doImport(this.state.droppedFile);
        } else if (this.state.selectedFile) {
            this.doImport(this.state.selectedFile);
        } else {
            this.setState({ isFormValid: false });
        }
    }

    doImport = async (importFile) => {
        this.setState({ isImporting: true, importErrors: [] });
        try {
            const response = await this.props.locationActions.import(this.props.subscriptionId, importFile);
            if (response.type === types.IMPORT_LOCATION_SUCCESS) {
                if (response.payload.importErrors && response.payload.importErrors.length > 0) {
                    Notification("error", "Validation Errors", "Please correct the errors in the Excel document and try again");
                    this.setState({
                        importErrors: response.payload.importErrors,
                        isImporting: false,
                        selectedFile: null,
                        droppedFile: null
                    });
                    // hack to clear the file out of the file input
                    // eslint-disable-next-line react/no-direct-mutation-state
                    this.state.fileInputTarget.value = null;
                } else {
                    Notification("success", "Import Successful", "");
                    this.props.onComplete();
                }
            } else if (response.type === types.IMPORT_LOCATION_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.setState({ isImporting: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isImporting: false });
        }
    }

    onDownload = async () => {
        this.props.locationActions.importTemplate()
            .then(error => {
                if (error) {
                    Notification("error", "", error);
                }
            });

    }

    render() {
        return (
            <div>
                <Drawer isWide={true} title='Location Import' onCancelClick={this.props.onCancel} saveText="Import" onSaveClick={this.onImportClick}>
                    <LoadingIndicator isLoading={this.state.isImporting}>
                        <div className="row">
                            <div className="col-1"><h1><span className="pacer-step-badge">1</span></h1></div>
                            <div className="col-9"><div className="mt-3">Download the import tool Excel template</div></div>
                            <div className="col-1"><div className="mt-1"><Button type="btn" bootstrapClass="primary text-end" onClick={this.onDownload} text="Download" /></div></div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-1"><h1><span className="pacer-step-badge">2</span></h1></div>
                            <div className="col-11"><div className="mt-2">Add your locations to the Excel template. Ensure all required fields are entered in for each location. If you copy/paste from another workbook, please use Paste Special &gt; Values.</div></div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-1"><h1 className="mt-2"><span className="pacer-step-badge">3</span></h1></div>
                            <div className="col-11">
                                <DropZone
                                    noClick={true}
                                    accept={{
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [], // Accepts .xlsx files
                                    }}
                                    multiple={false}
                                    onDrop={this.onDrop}
                                    onDragEnter={this.onDragEnter}
                                    onDragLeave={this.onDragLeave}
                                >
                                    {({ getRootProps, getInputProps, isDragActive }) => (
                                        <div {...getRootProps({ className: `dropzone ${isDragActive ? 'active' : ''}` })}>
                                            <input {...getInputProps()} />
                                            {isDragActive ? (
                                                <div className="dropzone-overlay">
                                                    <div className="overlay-content">
                                                        <Icon name="cloud-upload-alt" />
                                                        <p>Drop file here to import</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <p>Drag and drop a file here or select one below</p>
                                                    <FileChooser
                                                        name="file"
                                                        onChange={this.onFileChange}
                                                        isRequired
                                                        errorMessage="A file is required"
                                                        acceptTypes=".xlsx"
                                                    />
                                                    {this.state.droppedFile && (
                                                        <div className="dropped-file">File Name: {this.state.droppedFile.name}</div>
                                                    )}
                                                    {!this.state.isFormValid && (
                                                        <div className="text-danger">
                                                            You must select or drag and drop a valid excel file
                                                        </div>
                                                    )}
                                                    {this.state.importErrors.length > 0 && (
                                                        <>
                                                            <div className="text-danger">
                                                                {this.state.importErrors.length} error
                                                                {this.state.importErrors.length === 1 ? '' : 's'} found during the import:
                                                            </div>
                                                            {this.state.importErrors.map((importError) => (
                                                                <ImportErrorRow
                                                                    importError={importError}
                                                                    key={`${importError.rowNumber}-${importError.columnNumber}`}
                                                                />
                                                            ))}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </DropZone>

                            </div>
                        </div>
                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

LocationImportDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationActions: PropTypes.object.isRequired
};

